
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, Search } from "lucide-react";

interface TopSearchesTableProps {
  data: Array<{
    query: string;
    count: number;
    avgResults: number;
  }>;
  isLoading: boolean;
  title?: string;
}

export const TopSearchesTable = ({ data, isLoading, title = "Top Zoekopdrachten" }: TopSearchesTableProps) => {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Search className="h-5 w-5" />
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-center h-64">
          <Loader2 className="h-6 w-6 animate-spin" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Search className="h-5 w-5" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            Nog geen zoekopdrachten in deze periode
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Zoekopdracht</TableHead>
                <TableHead className="text-right">Aantal</TableHead>
                <TableHead className="text-right">Gem. Resultaten</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((search, index) => (
                <TableRow key={index}>
                  <TableCell className="font-medium">
                    {search.query || 'Lege zoekopdracht'}
                  </TableCell>
                  <TableCell className="text-right">{search.count}</TableCell>
                  <TableCell className="text-right">{search.avgResults}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
